module.exports = __webpack_public_path__ + "img/leftside_100.638b9351.jpg";